import { http } from '../api/http-client';
import { BlogMeta, CourseMeta } from '../types/blog.model';

export const getCourses = async (locale?: string): Promise<CourseMeta[]> => {
  const params: Record<string, string> = {};
  if (locale) params.locale = locale;
  const response = await http.get<{ courses: CourseMeta[] }>('/courses', { params });
  return response.data.courses;
};

export const getCourseBySlug = async (
  courseSlug: string,
  locale?: string
): Promise<{ course: CourseMeta; series: BlogMeta[] }> => {
  const params: Record<string, string> = {};
  if (locale) params.locale = locale;
  const response = await http.get<{ course: CourseMeta; series: BlogMeta[] }>(
    `/courses/${courseSlug}`,
    { params }
  );
  return response.data;
};
